import React from 'react';

import HaloPieSegment from 'components/HaloPieSegment';

const HaloPie = (props) => {
  const { data, pieArc } = props;

  return (
    <g>
      {data.map((d, i) => {
        return (
          <HaloPieSegment key={i} d={pieArc(d)} />
        )
      })}
    </g>
  )
};

export default HaloPie;
